import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { green } from '@mui/material/colors';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { connect } from 'react-redux';
import { S_JUR } from '@lba-dev/package.local-globals/services';

import Dropdown from '../Stats/common/dropdown/dropdown';
import { getTime } from '../../utils/date';
import TimePicker from '../TimePicker';

const mapStateToProps = ({ users, connectedUser }) => ({
  users,
  userId: connectedUser._id,
  user: connectedUser,
  permissionTimer: permit(connectedUser, { key: 'accessTimerLitiges' }),
});

class AddDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      save: false,
      open: false,
      os: '',
      loading: false,
      interId: '',
      user: null,
      users: props.users.filter(
        (e) =>
          e.act &&
          e.service === S_JUR &&
          !permit(e, { key: 'accessTimerLitiges' })
      ),
      value: dayjs('01:30', 'HH:mm').toDate(),
    };
    this.onValidate = this.onValidate.bind(this);
    this.onReject = this.onReject.bind(this);
    this.setData = this.setData.bind(this);
    this.setTimeValue = this.setTimeValue.bind(this);
    this.onValidateAndPris = this.onValidateAndPris.bind(this);
  }

  setTimeValue(e) {
    this.setState({
      value: dayjs(e.target.value, 'HH:mm').toDate()
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.open !== nextProps.open || this.state !== nextState;
  }

  convertTime(timer) {
    const tmp = dayjs();
    tmp.add(timer.hour(), 'h');
    tmp.add(timer.minute(), 'm');
    return tmp.toISOString();
  }

  onValidate() {
    if (typeof this.props.callback === 'function') {
      const { user, value } = this.state;
      this.props.callback(
        this.state.os,
        false,
        user && user._id,
        this.convertTime(dayjs(value))
      );
    }
  }

  onValidateAndPris() {
    if (typeof this.props.callback === 'function') {
      this.props.callback(this.state.os, true);
    }
  }

  onReject() {
    if (typeof this.props.callback === 'function') {
      this.props.callback();
    }
  }

  handleChange = (name) => (e) => {
    this.setState({ [name]: e.target.value });
  };

  setData(e) {
    this.setState({ os: e.target.value });
  }

  render() {
    const { permissionTimer } = this.props;
    const { user, users } = this.state;
    return (
      <Dialog open={this.props.open}>
        <DialogTitle>{this.props.defaultText.title}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} justifyContent="center"
            alignItems="flex-end">
            <Grid item xs={12}>
              <TextField
                variant="standard"
                type={'string'}
                label="Numero OS"
                onChange={this.setData}
                fullWidth
                value={this.state.os} />
            </Grid>
            {permissionTimer && (
              <>
                {' '}
                <Grid item xs={6}>
                  <TimePicker
                    label={'Délai'}
                    name="delay"
                    value={getTime(this.state.value)}
                    onChange={this.setTimeValue}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Dropdown
                    title={user ? user.login : 'Selectionnez un utilisateur'}
                    data={users}
                    idKey={null}
                    renderKey={'login'}
                    isSelected={(e) => user === e}
                    onChange={this.handleChange('user')}
                    multiple={false}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.onValidateAndPris}
            style={{ color: green[500] }}
          >
            Valider et prise en charge
          </Button>
          <Button onClick={this.onReject} color="secondary">
            {'Annuler'}
          </Button>
          <Button onClick={this.onValidate} color="primary">
            Valider
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(mapStateToProps)(AddDialog);
